import { FC, useContext } from "react";
import DataTable from "../../../../../shared/components/dataTable";
import { useNavigate } from "react-router-dom";
import { SidebarContext } from "../../../../../contexts/SidebarContext";
import useQuery from "../../../../../shared/components/hooks/useQuery";
import Loader from "../../../../../shared/components/loader/linearProgress";
import NoPermissionContent from "../../../../../shared/components/noPermissionBanner";
import SearchBox from "../../../../../layouts/SidebarLayout/Header/SearchBox";
import { TableViewContainer } from "../../../../../shared/components/tableViewContainer";

const UserList: FC = () => {
  const navigate = useNavigate();
  const { payload, setPayload } = useContext(SidebarContext);

  const { loading, data, fetchData, error } = useQuery("/admin/user", {
    params: {
      ...payload,
    },
  });

  const userData = data as any;

  const navigateToDetails = () => {
    navigate("/user-controls/users/create");
  };

  const userDisplayColumns = ["admin.name", "phone", "email"];
  const titleBarNode = <SearchBox />;
  const titleBar = {
    title: "Users",
    headerTitle: "Users",
    buttonTitle: "Create",
    titleBarNodes: (userData?.totalItems || payload.search) && titleBarNode,
    onClick: navigateToDetails,
    disabled: userData?.entityPermissions
      ? !userData?.entityPermissions?.includes("User-Create")
      : false,
    subHeading: "",
    rowCount: userData?.totalItems,
  };

  return (
    <TableViewContainer titleBar={titleBar}>
      {loading && <Loader />}
      {(error as any)?.statusCode === 403 && <NoPermissionContent />}
      {!loading && !error && (
        <DataTable
          entityName="Users"
          data={userData?.items ?? []}
          displayColumns={userDisplayColumns}
          linkColumn="name"
          linkUrl="/user-controls/users"
          pagination={{ take: payload.take, skip: payload.skip }}
          setPagination={setPayload}
          totalItems={userData?.totalItems}
          deleteApiUrl="/admin/user"
          refetchFunction={fetchData}
          disabled={
            userData?.entityPermissions
              ? !userData?.entityPermissions?.includes("User-Delete")
              : false
          }
        />
      )}
    </TableViewContainer>
  );
};

export default UserList;
